import { CORE_SET } from './DeviceCategoryFilter.constants'

export const getNonCoreValues = (values: Iterable<string>) =>
  [...values].filter(value => !CORE_SET.has(value))

